export const ERROR_DUPLICATE_PROFILE = 'DUPLICATE_PROFILE';
export const ERROR_DEFAULT = 'default';
export const ERROR_HOST_NOT_FOUND = 'HOST_NOT_FOUND';
export const ERROR_BAD_INTEGRATION_CONFIGURATION = 'BAD_INTEGRATION_CONFIGURATION';
export const ERROR_EVENT_NOT_FOUND = 'EVENT_NOT_FOUND';
export const ERROR_BOOKING_FAILED = 'BOOKING_FAILED';
export const ERROR_BOOKING_PAYMENT_PROCESSING = 'BOOKING_PAYMENT_PROCESSING';
export const ERROR_BOOKING_CARD_DECLINED = 'BOOKING_CARD_DECLINED';
export const ERROR_BOOKING_SLOT_UNAVAILABLE = 'BOOKING_SLOT_UNAVAILABLE';
export const ERROR_BOOKING_SESSION_LIMIT = 'BOOKING_SESSION_LIMIT';
export const ERROR_BOOKING_SLOT_FULL = 'BOOKING_SLOT_FULL';
export const ERROR_BOOKING_DISCOUNT_INVALID = 'BOOKING_DISCOUNT_INVALID';
export const ERROR_NO_CONNECTED_PROVIDER = 'NO_CONNECTED_PROVIDER';
/** SBS 409: the booking is paid and confirming, so it cannot be cancelled yet (SMB-1785). */
export const ERROR_BOOKING_PAYMENT_IN_PROGRESS = 'BOOKING_PAYMENT_IN_PROGRESS';
export const ERROR_CANCEL_FAILED = 'CANCEL_FAILED';
export const ERROR_UPDATE_STATUS_FAILED = 'UPDATE_STATUS_FAILED';
export const ERROR_SAVE_PAYMENT_METHOD_FAILED = 'SAVE_PAYMENT_METHOD_FAILED';
/** Front-end only: an auth failure that outlived its token refresh (see `ErrorsProvider`). */
export const ERROR_SESSION_EXPIRED = 'session_expired';
